module.exports = __webpack_public_path__ + "assets/hamburger-ee1c72.svg";